import React, { FC, HTMLAttributes } from 'react';
import { CardArea, Header, Content, Footer } from './styles';

interface CardProps extends HTMLAttributes<HTMLDivElement> {}

const Card: FC<CardProps> = ({ children, ...rest }) => {
    return (
        <CardArea {...rest} className={`card ${rest.className || ''}`}>
            {children}
        </CardArea>
    );
};

const CardHeader: FC<CardProps> = ({ children, ...rest }) => {
    return (
        <Header {...rest} className={`card-header ${rest.className || ''}`}>
            {children}
        </Header>
    );
};

const CardContent: FC<CardProps> = ({ children, ...rest }) => {
    return (
        <Content {...rest} className={`card-content ${rest.className || ''}`}>
            {children}
        </Content>
    );
};

const CardFooter: FC<CardProps> = ({ children, ...rest }) => {
    return (
        <Footer {...rest} className={`card-footer ${rest.className || ''}`}>
            {children}
        </Footer>
    );
};

export { Card, CardContent, CardFooter, CardHeader };
